import svgImage from '../assets/1_marker_image.svg?raw';
import svgVideo from '../assets/2_marker_video.svg?raw';
import svgObject from '../assets/3_marker_object.svg?raw';
import svgText from '../assets/4_marker_text.svg?raw';
import svgDocument from '../assets/5_marker_document.svg?raw';
import svgAudio from '../assets/6_marker_audio.svg?raw';
import svgPersons from '../assets/7_marker_persons.svg?raw';
import svgDefault from '../assets/default.svg?raw';

// New category: import hinzufügen + Zeile in svgMarkerConfig
// Auf der Karte hat ein Dokument immer genau eine Kategorie 1–7. 'default' = Sicherheitsnetz für eine
// unerwartete category_id (siehe MarkerFactory.createDocumentMarker).
// Kategorie 99 ist KEINE Karten-Kategorie (optionales „hat-Fragen"-Attribut, nur Kategorie-Menü +
// Result-Div, nie ein Karten-Marker) → siehe Backlog „Analyse Kategorie 99".
export const svgMarkerConfig = {
    1: {'full': svgImage, class: 'image', 'segment': null},
    2: {'full': svgVideo, class: 'video', 'segment': null },
    3: {'full': svgObject, class: 'object', 'segment': null },
    4: {'full': svgText, class: 'text', 'segment': null },
    5: {'full': svgDocument, class: 'document', 'segment': null },
    6: {'full': svgAudio, class: 'audio', 'segment': null },
    7: {'full': svgPersons, class: 'persons', 'segment': null },
    'default': {'full': svgDefault, class: 'default', 'segment': null }
};